import * as React from 'react';
import {IVehicle, IVehicleLookup} from '../../../../../../data/api/models';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import {Field} from 'redux-form';
import {isRequired} from '../../../../../../util/validators';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import FaCheck from 'react-icons/fa/check';
import DVLAControl from '../../../../../../components/DVLAControl';

interface IVehicleProps {
  index: number;
  name: string;
  vehicle: IVehicle;
  dispatch: any;
  change: any;
  renderDefinition: any;
  duplicateRegistration: boolean;
}

interface IVehicleState {
  dvlaSearchCheck: any;
}

class Vehicle extends React.Component<IVehicleProps, IVehicleState> {
  public state = {
    dvlaSearchCheck: false,
  };
  private completeLookup = (vehicleLookup: IVehicleLookup) => {
    const { dispatch, change, name } = this.props;

    dispatch(change(name + '.make', vehicleLookup.make));
    dispatch(change(name + '.model', vehicleLookup.model));
  }

  private checkSearch = () => {
    this.setState({
      dvlaSearchCheck: true,
    });
  }

  public render() {
    const { index, name, vehicle, renderDefinition, duplicateRegistration } = this.props;
    const normalizeRegistration = (value) => value && value.toUpperCase();
    if (vehicle.make === 'UNKNOWN') {
      vehicle.make = '';
    }
    if (vehicle.model === 'UNKNOWN') {
      vehicle.model = '';
    }

    return (
      <div>
        <Row>
          <Col sm={1}>
            <img src={require('../../../../img/vehicle.svg')} alt="" />
          </Col>
          <Col sm={11} className="vehicle-info-centre-subtitle">
            Agricultural Vehicle {index + 1}
          </Col>
        </Row>
        <Row>
          <Col smOffset={1} sm={4} className="vehicle-info-centre">
            {renderDefinition('b2c_vehicle_road_registered')}
            Is this vehicle road registered?
          </Col>
          <Col sm={7}>
            <FormGroup controlId="vehicle.road_registered">
              <Col sm={12}>
                <Row className="button-group-container">
                  <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                    <Field
                      name={name + '.roadRegistered'}
                      type="radio"
                      value="false"
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    >
                      <div className={'button-group-btn'}>
                        No
                        <FaCheck/>
                      </div>
                    </Field>
                  </Col>
                  <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                    <Field
                      name={name + '.roadRegistered'}
                      type="radio"
                      value="true"
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    >
                      <div className={'button-group-btn'}>
                        Yes
                        <FaCheck/>
                      </div>
                    </Field>
                  </Col>
                </Row>
              </Col>
            </FormGroup>
          </Col>
        </Row>

        {vehicle.roadRegistered && (
          <>
            {vehicle.roadRegistered !== 'false' ? (
              <Row>
                <Col smOffset={1} componentClass={ControlLabel} sm={4}>
                  Registration Number:
                </Col>
                <Col sm={7}>
                  <FormGroup controlId={'vehicle.registration_number'}>
                    <Col sm={12} className="no-padding-left">
                      <Col sm={10}>
                        <Field
                          name={name + '.registrationNumber'}
                          component={DVLAControl}
                          onComplete={this.completeLookup}
                          validate={[ isRequired ]}
                          normalize={normalizeRegistration}
                          placeholder="Registration Number"
                          checkSearch={this.checkSearch}
                          duplicateRegistration={duplicateRegistration}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col smOffset={1} componentClass={ControlLabel} sm={4}>
                  Serial Number:
                </Col>
                <Col sm={4}>
                  <FormGroup controlId={'vehicle.registration_number'}>
                    <Col sm={12} className="no-padding-left">
                      <Col sm={10}>
                        <Field
                          name={name + '.registrationNumber'}
                          component={FieldFormControl}
                          validate={[ isRequired ]}
                          placeholder="Serial Number"
                          onFocus={this.checkSearch}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            )}
          </>
        )}
        {vehicle.registrationNumber && (
          <Row>
            <Col smOffset={1} componentClass={ControlLabel} sm={4}>
              Vehicle Make:
            </Col>
            <Col sm={4}>
              <FormGroup controlId={'vehicle.make'}>
                <Col sm={12} className="no-padding-left">
                  <Col sm={10}>
                    <Field
                      name={name + '.make'}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                      placeholder="Make"
                    />
                  </Col>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        )}
        {vehicle.make && (
          <Row>
            <Col smOffset={1} componentClass={ControlLabel} sm={4}>
              Vehicle Model:
            </Col>
            <Col sm={4}>
              <FormGroup controlId={'vehicle.model'}>
                <Col sm={12} className="no-padding-left">
                  <Col sm={10}>
                    <Field
                      name={name + '.model'}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                      placeholder="Model"
                    />
                  </Col>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default (Vehicle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Quote/components/Vehicle/index.tsx